import React, { Component } from 'react'
import { Modal, ModalFooter, Row, Col } from 'reactstrap'
import styled from 'styled-components'
import StyledTextarea from '../Forms/Textarea'
import StyledButton from '../Forms/Button'

import { withNamespaces } from 'react-i18next'

import Preloader from '../UI/Preloader'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 35px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
`

const StyledTitle = styled.div`
  margin-bottom: 30px;
  /* margin: 30px auto; */
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;
`

class Disagreement extends Component {
  state = {
    modal: false,
    comment: ''
  }

  // TODO Rename function
  closeTicketHandler = () => {
    this.props.sendDisagreement(this.state.comment)
    this.closeModal()
  }

  commentInputHandler = (ev) => {
    const { value } = ev.target

    this.setState({
      comment: value
    })
  }

  closeModal = () => {
    const { toggle, allowToClose } = this.props
    if (!allowToClose) {
      return null
    }

    this.setState(
      {
        comment: ''
      },
      () => {
        toggle()
      }
    )
  }

  render() {
    const { isOpen, isTicketClosed, t, allowToClose, loading } = this.props
    const { comment } = this.state

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.closeModal}
        contentClassName="styled_modal_content"
      >
        {loading && <Preloader />}
        <StyledModalContent>
          <StyledTitle>
            {isTicketClosed
              ? t('tickets:reopenOrDisagree')
              : t('tickets:escalation')}
          </StyledTitle>

          <Row>
            <Col sm={12}>
              <StyledTextarea
                type="textarea"
                input={{
                  value: comment,
                  name: 'reason',
                  id: 'reason',
                  onChange: this.commentInputHandler
                }}
                label={t('tickets:reason')}
              />
            </Col>
          </Row>

          <ModalFooterWrapper>
            {allowToClose && (
              <StyledButton onClick={this.closeModal} outline bgColor="#fff">
                {t('common:cancel')}
              </StyledButton>
            )}
            <StyledButton
              disabled={comment === ''}
              onClick={this.closeTicketHandler}
            >
              {isTicketClosed ? t('tickets:reopen') : t('tickets:escalate')}
            </StyledButton>
          </ModalFooterWrapper>
        </StyledModalContent>
      </Modal>
    )
  }
}

Disagreement.defaultProps = {
  allowToClose: true,
  loading: false
}

export default withNamespaces()(Disagreement)
